export default __webpack_public_path__ + "static/media/ello-logo-transparent-white.ca170416.png";